// Guided /journey mode. Free accounts get ONE server-enforced journey; guests get a server-issued guest journey
// (X-Journey-Id, kept 7 days). The session flag only adds the X-Journey header.
const FLAG = "fionova_journey";
const GUEST = "fionova_journey_guest";
import { getToken } from "@/lib/auth";

const SESSION_KEYS = ["fionova_unsaid_live", "fionova_unsaid_transcript", "fionova_unsaid_reveal_cache", "fionova_xray_cache", "fionova_todayplan_cache",
  "fionova_futureself_cache", "fionova_futureself_chat", "fionova_purpose_chat"];
const STEP_KEYS = [...SESSION_KEYS, "fionova_unsaid_outcome", "fionova_xray_outcome", "fionova_todayplan_outcome",
  "fionova_futureself_outcome", "fionova_purpose_outcome", "fionova_book_outcome"];
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const read = (k) => { try { return sessionStorage.getItem(k) ?? localStorage.getItem(k); } catch { return null; } };

export const journey = {
  isOn: () => { try { return sessionStorage.getItem(FLAG) === "1"; } catch { return false; } },
  on: () => { try { sessionStorage.setItem(FLAG, "1"); } catch {} },
  off: () => { try { sessionStorage.removeItem(FLAG); } catch {} },
  guestId: () => { try { return localStorage.getItem(GUEST); } catch { return null; } },
  setGuestId: (id) => { try { if (id) localStorage.setItem(GUEST, id); else localStorage.removeItem(GUEST); } catch {} },
  setStep: (path) => { try { localStorage.setItem("fionova_journey_step", path); } catch {} },
  lastStep: () => { try { return localStorage.getItem("fionova_journey_step"); } catch { return null; } },
  // Fresh start only: clear earlier step results left in this browser.
  resetSteps: () => [...STEP_KEYS, "fionova_journey_step"].forEach((k) => { try { sessionStorage.removeItem(k); localStorage.removeItem(k); } catch {} }),
  // Step results in this browser, for the server-side copy (resume on any device).
  snapshot: () => Object.fromEntries(STEP_KEYS.map((k) => [k, read(k)]).filter(([, v]) => v)),
  restore: (data) => Object.entries(data || {}).forEach(([k, v]) => {
    if (!STEP_KEYS.includes(k) || typeof v !== "string") return;
    try { (SESSION_KEYS.includes(k) ? sessionStorage : localStorage).setItem(k, v); } catch {}
  }),
};

export const journeyHeaders = () => {
  const h = journey.isOn() ? { "X-Journey": "1" } : {};
  const g = journey.guestId();
  return g ? { ...h, "X-Journey-Id": g } : h;
};

// After sign-in / sign-up: move the guest journey onto this one account (never a second account).
export async function claimGuestJourney() {
  const token = getToken();
  if (!journey.guestId() || !token) return null;
  try {
    const res = await fetch(`${API}/journey/claim`, { method: "POST", headers: { Authorization: `Bearer ${token}`, ...journeyHeaders() } });
    const data = await res.json().catch(() => ({}));
    if (res.ok && !data.deferred) journey.setGuestId(null);
    if (res.status === 404) journey.setGuestId(null);
    return data;
  } catch { return null; }
}

// Signed in from the journey: claim the guest journey, then resume exactly where the person was.
export async function afterJourneyAuth(navigate, refresh) {
  await claimGuestJourney();
  const u = await refresh();
  const step = journey.lastStep();
  if (u?.journey_status === "completed" && !journey.guestId()) navigate("/journey/complete");
  else if (u?.journey_status === "active" && journey.isOn() && step) navigate(step);
  else if (u?.entitled && !journey.guestId()) navigate("/app");
  else navigate("/journey");
}
